import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrustAi = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_32000_446141)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M34.2711 4.74904C33.6882 4.16429 33.6882 3.22868 34.2711 2.64393L36.2028 0.705882C36.7857 0.121128 37.7183 0.121128 38.3011 0.705882C38.884 1.29064 38.884 2.22624 38.3011 2.811L36.3694 4.74904C36.0863 5.03307 35.7033 5.18343 35.3202 5.18343C34.9372 5.18343 34.5708 5.03307 34.2711 4.74904ZM28.7423 8.20745C28.1594 8.7922 28.1594 9.72781 28.7423 10.3126C29.0254 10.5966 29.4084 10.747 29.7914 10.747C30.1744 10.747 30.5408 10.5966 30.8406 10.3126L32.7723 8.37452C33.3552 7.78977 33.3552 6.85416 32.7723 6.2694C32.1895 5.68465 31.2569 5.68465 30.674 6.2694L28.7423 8.20745ZM22.6473 55.2551L20.7155 57.1932C20.1327 57.7779 20.1327 58.7135 20.7155 59.2983C20.9986 59.5823 21.3817 59.7327 21.7647 59.7327C22.1477 59.7327 22.5141 59.5823 22.8138 59.2983L24.7456 57.3602C25.3284 56.7755 25.3284 55.8399 24.7456 55.2551C24.1627 54.6704 23.2301 54.6704 22.6473 55.2551ZM30.2744 51.7967C30.8572 51.212 30.8572 50.2764 30.2744 49.6916C29.6915 49.1069 28.7589 49.1069 28.1761 49.6916L26.2443 51.6297C25.6615 52.2144 25.6615 53.15 26.2443 53.7348C26.5274 54.0188 26.9105 54.1692 27.2935 54.1692C27.6765 54.1692 28.0429 54.0188 28.3426 53.7348L30.2744 51.7967ZM28.0262 40.6864C28.0262 35.6074 23.9129 31.4807 18.8504 31.4807C18.0344 31.4807 17.3683 30.8124 17.3683 29.9937C17.3683 29.1751 18.0344 28.5068 18.8504 28.5068C23.9129 28.5068 28.0262 24.3801 28.0262 19.3011C28.0262 18.4824 28.6923 17.8141 29.5083 17.8141C30.3243 17.8141 30.9904 18.4824 30.9904 19.3011C30.9904 24.3801 35.1037 28.5068 40.1663 28.5068C40.9823 28.5068 41.6484 29.1751 41.6484 29.9937C41.6484 30.8124 40.9823 31.4807 40.1663 31.4807C35.1037 31.4807 30.9904 35.6074 30.9904 40.6864C30.9904 41.505 30.3243 42.1733 29.5083 42.1733C28.6923 42.1733 28.0262 41.505 28.0262 40.6864ZM29.5083 34.8723C30.6241 32.8173 32.3227 31.1298 34.3544 30.0104C32.306 28.8911 30.6241 27.1869 29.5083 25.1486C28.3926 27.2036 26.694 28.8911 24.6623 30.0104C26.7106 31.1298 28.3926 32.834 29.5083 34.8723ZM22.9637 52.749C23.3301 52.5987 23.6132 52.3147 23.763 51.9471C23.8296 51.7633 23.8796 51.5795 23.8796 51.379V45.732C23.8796 44.9133 23.2135 44.245 22.3975 44.245C21.5815 44.245 20.9154 44.9133 20.9154 45.732V47.787L3.17991 29.9937L30.5575 2.54368C31.1403 1.95893 31.1403 1.02332 30.5575 0.438566C29.9746 -0.146189 29.042 -0.146189 28.4592 0.438566L-1 29.9937L18.8337 49.8921H16.7854C15.9694 49.8921 15.3033 50.5604 15.3033 51.379C15.3033 52.1977 15.9694 52.866 16.7854 52.866H22.4141C22.614 52.866 22.7972 52.8326 22.9803 52.749H22.9637ZM40.1829 10.0954H42.2312C43.0472 10.0954 43.7133 9.42708 43.7133 8.60842C43.7133 7.78977 43.0472 7.12148 42.2312 7.12148H36.6025C36.4027 7.12148 36.2195 7.15489 36.0363 7.23843C35.6699 7.38879 35.3868 7.67282 35.237 8.04038C35.1703 8.22416 35.1204 8.40794 35.1204 8.60842V14.2555C35.1204 15.0741 35.7865 15.7424 36.6025 15.7424C37.4185 15.7424 38.0846 15.0741 38.0846 14.2555V12.2005L55.8201 29.9937L28.4425 57.4605C27.8597 58.0452 27.8597 58.9809 28.4425 59.5656C28.7256 59.8496 29.1087 60 29.4917 60C29.8747 60 30.2411 59.8496 30.5408 59.5656L60 30.0104L40.1663 10.1121L40.1829 10.0954Z",
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_32000_446141",
			x1: 29.5083,
			y1: 60,
			x2: 29.5083,
			y2: .0041768,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "currentColor" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .34,
					stopColor: "currentColor"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .63,
					stopColor: "currentColor"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .86,
					stopColor: "currentColor"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#00A8CF"
				})
			]
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_32000_446141",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 60,
				height: 60,
				fill: "white"
			})
		})] })
	]
});
const ForwardRef = forwardRef(SvgTrustAi);
export default ForwardRef;
